import React from "react";
import { NavLink, Outlet } from "react-router-dom";
import { LayoutDashboard, BarChart3, Receipt, UserCog } from "lucide-react";
import { cn } from "@/lib/utils";
import { useAuth } from "@/lib/AuthContext";

const nav = [
  { to: "/dashboard/client", label: "Overview", icon: LayoutDashboard, end: true },
  { to: "/dashboard/client/reports", label: "Reports", icon: BarChart3 },
  { to: "/dashboard/client/invoices", label: "Invoices", icon: Receipt },
  { to: "/dashboard/client/account", label: "Account", icon: UserCog },
];

function NavItem({ to, label, icon: Icon, end }) {
  return (
    <NavLink
      to={to}
      end={end}
      className={({ isActive }) =>
        cn(
          "flex items-center gap-2.5 px-3 py-2 text-sm rounded-r-lg border-l-2 transition-colors",
          isActive
            ? "bg-accent text-foreground font-medium border-l-primary"
            : "text-muted-foreground border-l-transparent hover:bg-accent/60"
        )
      }
    >
      <Icon className="w-4 h-4 shrink-0" />
      {label}
    </NavLink>
  );
}

export default function ClientLayout() {
  const { profile, signOut } = useAuth();

  return (
    <div className="grid grid-cols-[220px_1fr] min-h-screen bg-background text-foreground">
      <aside className="border-r border-border bg-card px-4 py-6 flex flex-col">
        <div className="px-2 pb-2">
          <div className="font-bold text-base tracking-tight">Client dashboard</div>
          <div className="font-mono text-[11px] uppercase tracking-wide text-muted-foreground mt-0.5">
            abhinavjoshi.com
          </div>
        </div>

        <div className="flex items-center gap-2 px-2 py-2 border-b border-border mb-3">
          <div className="w-6.5 h-6.5 rounded-md bg-primary text-primary-foreground flex items-center justify-center text-[11px] font-semibold">
            {profile?.client_id ? "C" : ""}
          </div>
          <div className="text-sm font-medium">Your account</div>
        </div>

        <nav className="flex flex-col gap-0.5">
          {nav.map((item) => (
            <NavItem key={item.to} {...item} />
          ))}
        </nav>

        <div className="mt-auto pt-3 border-t border-border font-mono text-xs text-muted-foreground flex items-center justify-between">
          <span>{profile?.full_name || profile?.email}</span>
          <button onClick={signOut} className="underline hover:text-foreground">
            Sign out
          </button>
        </div>
      </aside>

      <main className="p-8">
        <Outlet />
      </main>
    </div>
  );
}
